export var DAY_OF_WEEK = /* @__PURE__ */ ((DAY_OF_WEEK2) => {
  DAY_OF_WEEK2[DAY_OF_WEEK2["SUNDAY"] = 0] = "SUNDAY";
  DAY_OF_WEEK2[DAY_OF_WEEK2["MONDAY"] = 1] = "MONDAY";
  DAY_OF_WEEK2[DAY_OF_WEEK2["TUESDAY"] = 2] = "TUESDAY";
  DAY_OF_WEEK2[DAY_OF_WEEK2["WEDNESDAY"] = 3] = "WEDNESDAY";
  DAY_OF_WEEK2[DAY_OF_WEEK2["THURSDAY"] = 4] = "THURSDAY";
  DAY_OF_WEEK2[DAY_OF_WEEK2["FRIDAY"] = 5] = "FRIDAY";
  DAY_OF_WEEK2[DAY_OF_WEEK2["SATURDAY"] = 6] = "SATURDAY";
  return DAY_OF_WEEK2;
})(DAY_OF_WEEK || {});
